//#region types
import { InvoiceSectionProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { ReadOnlyVerticalFormField, DateDisplay, TextDisplay, GroupSectionInline } from "components/common/wintForms";
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const RecurringInvoiceDateSection: React.FC<InvoiceSectionProps> = (props) => {
  const { values } = props;

  return (
    <GroupSectionInline
      key={`recurring-invoice-date-section`}
      label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Dates)}
      icon={IconDefinitionConstants.WCalendar}
    >
      {!!values.recurringInvoiceStartDate && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={DateDisplay}
            value={values.recurringInvoiceStartDate}
            label={TranslationKeys.Invoice.FirstInvoice}
          />
        </Grid>
      )}
      {!!values.recurringDeliveryAfterDays && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={TextDisplay}
            value={values.recurringDeliveryAfterDays}
            label={TranslationKeys.Invoice.DeliveryDate}
          />
        </Grid>
      )}
      {!!values.recurringInvoiceFrequencyName && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={TextDisplay}
            value={values.recurringInvoiceFrequencyName}
            label={TranslationKeys.Invoice.HowOften}
          />
        </Grid>
      )}
      {!!values.recurringInvoiceLastInvoice && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={TextDisplay}
            value={values.recurringInvoiceLastInvoice}
            label={TranslationKeys.Invoice.LastInvoice}
          />
        </Grid>
      )}
    </GroupSectionInline>
  );
};

export default RecurringInvoiceDateSection;
